import { render, staticRenderFns } from "./BaseReportingRegistry.vue?vue&type=template&id=6e41af3c"
import script from "./BaseReportingRegistry.vue?vue&type=script&lang=js"
export * from "./BaseReportingRegistry.vue?vue&type=script&lang=js"
import style0 from "./BaseReportingRegistry.vue?vue&type=style&index=0&id=6e41af3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports